import { type ReactNode, useContext } from 'react';

import { type TaxpayerRegistrationFieldConfiguration } from '../../Parameters/TaxpayerFieldRegistration/types';

import { TaxpayerRegistrationContext } from './pages/request';

interface VisibleComponentProps {
  /**
   * Contenido que se renderizará cuando el campo esté habilitado.
   */
  children?: ReactNode;

  /**
   * Código del campo cuya configuración se desea consultar.
   */
  fieldCode: string;

  /*
   * Indica si lo que se debe hacer es dibujar el componente pero
   * solamente oculatarlo en lugar de directamente no dibujarlo
   */
  hideOnly?: boolean;
}

/**
 * Renderiza sus hijos únicamente cuando el campo indicado
 * está registrado y habilitado dentro de MyContext.
 */
const VisibleComponent = ({ children, fieldCode, hideOnly }: VisibleComponentProps) => {
  // Lista de configuraciones de campos disponible en el contexto.
  const conf = useContext<TaxpayerRegistrationFieldConfiguration>(TaxpayerRegistrationContext);

  // No renderizar contenido si el campo no existe o está deshabilitado.
  if (!conf.fields.some((x) => x == fieldCode)) {
    if (hideOnly) {
      return <div className="d-none">{children}</div>;
    }

    return null;
  }

  return <>{children}</>;
};

export default VisibleComponent;
